<template>
    <send-list
        v-loading="isBusy"
        ref="list"
        :base-url="baseUrl"
        :margin="16"
        :contact-search-url="contactSearchUrl"
        @quick-message="onSendQuickMessage"
        @email-message="onEmailMessage"
        @edit="onEdit"
        @delete="onDelete"
        @change="onChange"
    >
    </send-list>
</template>

<script>
  import SendList from "./send-list";
  import eventBus from "../../../event-bus";

  export default {
    props: {
      baseUrl: String,
      contactSearchUrl: String,
    },

    data() {
      return {
        isBusy: false,
        current: null,
      };
    },

    components: {
      'send-list': SendList,
    },

    methods: {
      /**
       * @param {Object} model
       */
      onSendListCreated({model}) {
        this.refreshSendLists();
      },

      /**
       * @param {Object} model
       */
      onSendListUpdated({model}) {
        this.refreshSendLists();
      },

      /**
       * @return {undefined}
       */
      refreshSendLists() {
        this.$refs.list.refreshList();
      },

      /**
       * @param {Object} quickBulkMessageUrl
       * @event show-quick-bulk-message
       */
      onSendQuickMessage({quickBulkMessageUrl}) {
        eventBus.$emit('show-quick-bulk-message', quickBulkMessageUrl);
      },

      /**
       * @param {Object} emailBulkMessageUrl
       * @event show-email-bulk-message-dialog
       */
      onEmailMessage({createEmailBulkMessageUrl}) {
        eventBus.$emit('show-email-bulk-message-dialog', createEmailBulkMessageUrl);
      },

      /**
       * @param {Object} item
       * @event show-send-list-modal-form
       */
      onEdit(item) {
        eventBus.$emit('show-send-list-modal-form', {
          title: 'EDIT GROUP',
          url: item.editUrl,
          model: {},
        });
      },

      /**
       * @param {Object} item
       */
      onDelete(item) {
        this.$confirm('Do you confirm deleting?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.deleteItem(item))
          .catch(() => {});
      },

      /**
       * @param {Object} item
       */
      deleteItem(item) {
        this.isBusy = true;
        const url = _.get(item, 'deleteUrl');
        if (url) {
          axios.delete(url)
            .then(({data: {message}}) => {
              this.$message.success(message);
              this.$refs.list.removeItemById(_.get(item, 'id'));
            })
            .finally(() => this.isBusy = false);
        }
      },

      /**
       * @param {Object|null} item
       */
      onChange(item) {
        eventBus.$emit('send-list-select', item);
      },
    },

    created() {
      eventBus.$on('send-list-created', this.onSendListCreated);
      eventBus.$on('send-list-updated', this.onSendListUpdated);
    },

    mounted() {
      eventBus.$emit('url-change', window.location);
    },

    beforeDestroy() {
      eventBus.$off('send-list-created', this.onSendListCreated);
      eventBus.$off('send-list-updated', this.onSendListUpdated);
    },
  }
</script>

